// eslint-disable-next-line import/prefer-default-export
export const receiveContactForms = 'FORM/receiveContactForms';
